export default "__VITE_ASSET__BzIB31Db__"